import React from 'react';
import { X, AlertCircle } from 'lucide-react';
interface ConfirmSituazioneModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  currentStatus: 'Regolare' | 'Non regolare';
  newStatus: 'Regolare' | 'Non regolare';
  companyName: string;
}
export function ConfirmSituazioneModal({
  isOpen,
  onClose,
  onConfirm,
  currentStatus,
  newStatus,
  companyName
}: ConfirmSituazioneModalProps) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-122">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black bg-opacity-50" onClick={onClose} data-id="element-123" />

      {/* Modal */}
      <div className="relative bg-white rounded-lg shadow-xl max-w-md w-full" data-id="element-124">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200" data-id="element-125">
          <div className="flex items-center gap-3" data-id="element-126">
            <div className="p-2 bg-orange-100 rounded-lg" data-id="element-127">
              <AlertCircle size={24} className="text-orange-600" data-id="element-128" />
            </div>
            <h2 className="text-lg font-semibold text-gray-900" data-id="element-129">
              Conferma Modifica
            </h2>
          </div>
          <button onClick={onClose} className="p-1 text-gray-400 hover:text-gray-600 rounded transition-colors" data-id="element-130">
            <X size={20} data-id="element-131" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6 space-y-4" data-id="element-132">
          <p className="text-gray-700" data-id="element-133">
            Stai per modificare la situazione contributiva di:
          </p>

          <div className="bg-gray-50 rounded-lg p-4 border border-gray-200" data-id="element-134">
            <p className="font-semibold text-gray-900 mb-2" data-id="element-135">{companyName}</p>
            <div className="flex items-center gap-2 text-sm" data-id="element-136">
              <span className="text-gray-600" data-id="element-137">Da:</span>
              <span className={`px-2 py-1 rounded-full text-xs font-semibold ${currentStatus === 'Regolare' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`} data-id="element-138">
                {currentStatus}
              </span>
              <span className="text-gray-600" data-id="element-139">→</span>
              <span className={`px-2 py-1 rounded-full text-xs font-semibold ${newStatus === 'Regolare' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`} data-id="element-140">
                {newStatus}
              </span>
            </div>
          </div>

          <p className="text-sm text-gray-600" data-id="element-141">
            Questa modifica verrà registrata nel sistema. Vuoi procedere?
          </p>
        </div>

        {/* Footer */}
        <div className="flex items-center justify-end gap-3 p-6 border-t border-gray-200 bg-gray-50" data-id="element-142">
          <button onClick={onClose} className="px-4 py-2 text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-143">
            Annulla
          </button>
          <button onClick={onConfirm} className="px-4 py-2 text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors" data-id="element-144">
            Conferma Modifica
          </button>
        </div>
      </div>
    </div>;
}